import Dto from "../../../../../lib/model/service/Dto";

class ActualizeVariables extends Dto {
  constructor(campaignId = '', pageId = '') {
    super('appl\\service\\campaign\\dto\\ActualizeVariables');
    this.campaignId = campaignId;
    this.pageId = pageId;
  }

  getCampaignId() {
    return this.campaignId;
  }

  setCampaignId(campaignId) {
    this.campaignId = campaignId;
  }

  getPageId(){
    return this.pageId;
  }

  setPageId(pageId){
    this.pageId = pageId;
  }

}

export default ActualizeVariables;
